import { render, staticRenderFns } from "./BaseFooterHeader.vue?vue&type=template&id=bcbb5a2e&scoped=true&"
import script from "./BaseFooterHeader.vue?vue&type=script&lang=js&"
export * from "./BaseFooterHeader.vue?vue&type=script&lang=js&"
import style0 from "./BaseFooterHeader.vue?vue&type=style&index=0&id=bcbb5a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbb5a2e",
  null
  
)

export default component.exports